import {html, css, LitElement} from 'lit';

export class DzFloatingButton extends LitElement {

    static properties = {
        action: {type: String},
        events: {type: String},
        side:   {type: String}   
    }

    constructor() {
        super()
        this.target = null
    }

    connectedCallback() {
        super.connectedCallback()
        let component = this

        for (let event of this.events.split(",")) {
            this.addEventListener(event.trim(), evt => {
                if (this.target) {
                    this.target.querySelectorAll(".floating-button").forEach(btn => btn.remove());
                }
                this.target = evt.target

                let btn = document.createElement("button")
                btn.classList.add("floating-button")
                btn.innerText = "Применить"
                
                btn.addEventListener("click", evt => {
                    component.runAction()
                    evt.stopPropagation()               
                })

                this.target.insertBefore(btn, this.target.childNodes[0]);
                this.requestUpdate()
            })
        }
    }

    render() {
        return html`<slot></slot>`
    }

    runAction() {
        let evt = new CustomEvent(this.action, {bubbles: true, composed: true})
        this.dispatchEvent(evt)
    }

    static styles = css`
        :host {
            display: block;
        }
    `

}

customElements.define('dz-floating-button', DzFloatingButton)